import type { GeoCountry, Location } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { type FormStatus, idleForm, idleLoad, type LoadStatus } from "../../core/primitives/load-status";
import {
  EMPTY_LOCATION,
  type LocationDraft,
  type LocationErrors,
  type LocationField,
} from "../../core/primitives/location-form";
import type { GeoRegionList } from "../../core/repositories/countries-repository";

export class OnboardingLocationsState {
  readonly storeId = new Rx<string | null>(null);
  readonly claimWalkthrough = new Rx(false);
  readonly locations = new RxList<Location>();
  readonly countries = new RxList<GeoCountry>();
  readonly countriesStatus = new Rx<LoadStatus>(idleLoad);

  /** The add form: on screen while there is no location. */
  readonly draft = new Rx<LocationDraft>(EMPTY_LOCATION);
  readonly regions = new Rx<GeoRegionList>([]);
  readonly errors = new Rx<LocationErrors>({});
  readonly addForm = new Rx<FormStatus>(idleForm);

  /** The one location being edited, if any. */
  readonly editingId = new Rx<string | null>(null);
  readonly editDraft = new Rx<LocationDraft>(EMPTY_LOCATION);
  readonly editRegions = new Rx<GeoRegionList>([]);
  readonly editErrors = new Rx<LocationErrors>({});
  readonly editForm = new Rx<FormStatus>(idleForm);
}

export abstract class OnboardingLocationsActions {
  abstract setField(field: LocationField, value: string): void;
  abstract add(): Promise<void>;
  abstract startEdit(locationId: string): void;
  abstract setEditField(field: LocationField, value: string): void;
  abstract saveEdit(): Promise<void>;
  abstract cancelEdit(): void;
  abstract back(): void;
  abstract next(): void;
}
